'use strict';

require('../../styles/theme.scss');

var _themeSections = require('@shopify/theme-sections');

var _themeA11y = require('@shopify/theme-a11y');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

require('../helpers/polyfill');

require('../helpers/lazysizes');

var _ajaxCart = require('../helpers/ajax-cart');

var _ajaxCart2 = _interopRequireDefault(_ajaxCart);

var _eventBus = require('../helpers/event-bus');

var _eventBus2 = _interopRequireDefault(_eventBus);

var _redirects = require('../helpers/redirects');

var _redirects2 = _interopRequireDefault(_redirects);

var _utils = require('../helpers/utils');

require('../sections/cart-drawer');

require('../sections/menu-drawer');

require('../sections/site-header');

require('../sections/fit-guide__image-slider');

var _hotspot = require('../components/hotspot');

var _hotspot2 = _interopRequireDefault(_hotspot);

var _meganav = require('../components/meganav');

var _meganav2 = _interopRequireDefault(_meganav);

var _autoRedirect = require('../components/auto-redirect');

var _autoRedirect2 = _interopRequireDefault(_autoRedirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Global Frame utils
 */


/**
 * Global components section imports.
 */


/**
 * Fit guide
 */
window.Frame = window.Frame || {};
/**
 * Global theme section imports.
 */


/**
 * Global theme helpers.
 */
/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts and registering sections and modules
 *
 */

window.Frame.EventBus = (0, _eventBus2.default)();

document.addEventListener('DOMContentLoaded', function () {
  if ((0, _utils.getBrowser)() === 'Internet Explorer') {
    var bodyTag = document.getElementsByTagName('body')[0];
    bodyTag.classList.add('IE');
    _axios2.default.defaults.headers.common = {
      // IE11 caching bug.
      Pragma: 'no-cache'
    };
  }

  (0, _themeSections.load)('*');
  (0, _ajaxCart2.default)().init();
  (0, _redirects2.default)().init();
  (0, _meganav2.default)().init();
  (0, _themeA11y.focusHash)();
  (0, _hotspot2.default)().init();
  (0, _themeA11y.bindInPageLinks)();
  (0, _autoRedirect2.default)().init();
});